import styled from "styled-components";
import sideImg from '../../assets/side.svg'


const ProjectsStyle = styled.section`

    font-family: 'Rubik', sans-serif;
    width: 100%;
    color: #02223C;
    box-sizing: content-box;
    background-color: #F3f3f3;
    display: flex;
    justify-content: center;

    .container {
        padding: 5rem 20px;
        max-width: 1280px;
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        .Projects {
            h1 {
                font-size: 3rem;
            }
        }
        .grid_projects {
            margin-top: 32px;
            display: grid;
            grid-template-columns: 1fr 1fr 1fr;
            .card {
                min-height: 320px;
                width: 100%;
                background-color: #ccc;
                &:hover {
                    filter: brightness(0.9);
                }
            }
        }
    }

    @media screen and (max-width: 600px) {
            .container {
                grid-template-columns: 1fr;
                padding: 6rem 20px 3rem 20px;
                text-align: center;
                .grid_projects {
                    margin-top: 32px;
                    display: grid;
                    grid-template-columns: 1fr;
                }
            }          

    }
`

export function Projects() {
    return(
        <ProjectsStyle id="projetos">
            <div className="container">
                <div className="Projects">
                    <h1>
                        Nossos Projetos
                    </h1>
                    <p>Lorem ipsum, dolor sit amet consectetur adipisicing elit. Nulla vero quaerat omnis esse minima numquam animi soluta, quae harum, delectus doloribus et magni doloremque eum placeat architecto ad similique corrupti itaque ratione?</p>
                </div>
                <div className="grid_projects">
                    <div className="card"></div>
                    <div className="card"></div>
                    <div className="card"></div>
                </div>
            </div>
        </ProjectsStyle>
    )
}